import { Progress } from "@/components/ui/progress";
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast";
import { useToast } from "@/hooks/use-toast";
import { Copy } from "lucide-react";
import { createPortal } from "react-dom";

export function Toaster() {
  const { toasts } = useToast();

  return (
    <ToastProvider>
      {toasts.map(({ id, title, description, action, variant, progress, ...props }) => {
        const isDestructive = variant === "destructive";
        const copyText = [title, description].filter(Boolean).join("\n");

        // If progress is defined, render as progress toast
        if (progress !== undefined) {
          return (
            <Toast key={id} variant={variant} {...props}>
              <div className={isDestructive ? "grid gap-1 flex-1 select-text" : "grid gap-1 flex-1"}>
                <div className="text-sm font-semibold">{title}</div>
                {description && (
                  <div className="text-sm text-muted-foreground">{description}</div>
                )}
                <div className="mt-2">
                  <Progress value={progress} className="h-2" />
                  <div className="text-xs text-muted-foreground mt-1 text-right">
                    {Math.round(progress)}%
                  </div>
                </div>
              </div>
              {isDestructive && copyText ? (
                <button
                  type="button"
                  aria-label="Copy error"
                  onClick={() => navigator.clipboard?.writeText(copyText)}
                  className="absolute right-9 top-2 inline-flex h-7 w-7 items-center justify-center rounded-md text-white/70 hover:text-white focus:outline-none focus:ring-2 focus:ring-white/40"
                >
                  <Copy className="h-4 w-4" />
                </button>
              ) : null}
              <ToastClose />
            </Toast>
          );
        }

        // Otherwise render as regular toast
        return (
          <Toast key={id} variant={variant} {...props}>
            <div className={isDestructive ? "grid gap-1 select-text" : "grid gap-1"}>
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && <ToastDescription>{description}</ToastDescription>}
            </div>
            {action}
            {isDestructive && copyText ? (
              <button
                type="button"
                aria-label="Copy error"
                onClick={() => navigator.clipboard?.writeText(copyText)}
                className="absolute right-9 top-2 inline-flex h-7 w-7 items-center justify-center rounded-md text-white/70 hover:text-white focus:outline-none focus:ring-2 focus:ring-white/40"
              >
                <Copy className="h-4 w-4" />
              </button>
            ) : null}
            <ToastClose />
          </Toast>
        );
      })}
      {createPortal(<ToastViewport />, document.body)}
    </ToastProvider>
  );
}
